/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Log_In_ContentInputs */

const en_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in or sign up to subscribe to Plus!`)
};

const ar_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم بتسجيل الدخول أو قم بالتسجيل للاشتراك في بلس!`)
};

const de_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden Sie sich an oder registrieren Sie sich, um Plus zu abonnieren!`)
};

const es_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Inicia sesión o regístrate para suscribirte a Plus!`)
};

const fr_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous ou inscrivez-vous pour vous abonner à Forest Plus!`)
};

const it_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi o registrati per abbonarti a Plus!`)
};

const ja_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログインまたはサインアップしてPlusに登録してください！`)
};

const ko_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인하거나 가입하여 Plus를 구독하세요!`)
};

const pt_br_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie sessão ou registre-se para assinar o Plus!`)
};

const ru_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите или зарегистрируйтесь, чтобы подписаться на Plus!`)
};

const th_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบหรือลงทะเบียนเพื่อสมัครสมาชิก Plus!`)
};

const tr_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus'a abone olmak için giriş yap veya kaydol!`)
};

const zh_cn_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入或注册后即可购买 Plus！`)
};

const zh_tw_dialog_log_in_content = /** @type {(inputs: Dialog_Log_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入或註冊後即可訂閱 Plus！`)
};

/**
* | output |
* | --- |
* | "Log in or sign up to subscribe to Plus!" |
*
* @param {Dialog_Log_In_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_log_in_content = /** @type {((inputs?: Dialog_Log_In_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Log_In_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_log_in_content(inputs)
	if (locale === "ar") return ar_dialog_log_in_content(inputs)
	if (locale === "de") return de_dialog_log_in_content(inputs)
	if (locale === "es") return es_dialog_log_in_content(inputs)
	if (locale === "fr") return fr_dialog_log_in_content(inputs)
	if (locale === "it") return it_dialog_log_in_content(inputs)
	if (locale === "ja") return ja_dialog_log_in_content(inputs)
	if (locale === "ko") return ko_dialog_log_in_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_log_in_content(inputs)
	if (locale === "ru") return ru_dialog_log_in_content(inputs)
	if (locale === "th") return th_dialog_log_in_content(inputs)
	if (locale === "tr") return tr_dialog_log_in_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_log_in_content(inputs)
	return zh_tw_dialog_log_in_content(inputs)
});